import { StockApiClient } from '@fourthwall/services/dist/StockApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const deleteStockMutationKey = 'deleteStock'

export const useDeleteStockMutation = createMutationHook(StockApiClient.deleteStock, {
  mutationKey: ['deleteStock'],
})
